import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
const principles = [{
  title: 'Integrity',
  text: 'The standard does not move with the pressure of the quarter.'
}, {
  title: 'Clarity',
  text: 'Complexity is the work; clarity is the deliverable.'
}, {
  title: 'Stewardship',
  text: 'Decisions are made for the institution that outlasts all of us.'
}];
export function Philosophy() {
  return <section className="boardroom-light relative overflow-hidden py-24 lg:py-32" data-id="element-196" data-mp="1yewu6bvan220">
      <div className="aurora" aria-hidden="true" data-id="element-197" data-mp="22fgprb07xxm1" />
      <div className="pattern-lattice-dark absolute inset-0 opacity-40" aria-hidden="true" data-id="element-198" data-mp="22cum3mgg8293" />
      <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10" data-id="element-199" data-mp="1ohieieh72har">
        <Reveal data-id="element-200" data-mp="1tcxsr7j46f7p">
          <QuoteIcon className="mx-auto h-8 w-8 text-gold" aria-hidden="true" data-id="element-201" data-mp="1tglmo7sh13my" />
          <p className="eyebrow mt-6 text-gold-light" data-id="element-202" data-mp="cyo40caymogc">Leadership Philosophy</p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-203" data-mp="i0wyjd3hdykk">
          <blockquote className="mt-8 font-display text-2xl font-light leading-[1.5] text-white sm:text-3xl lg:text-[2.1rem]" data-id="element-204" data-mp="hwzd2ktfkuxi">
            “Governance is not a constraint on ambition — it is the structure that makes ambition
            survivable. My work is to give leaders the clarity to move decisively and the discipline to
            move responsibly.”
          </blockquote>
        </Reveal>

        <Reveal delay={0.18} data-id="element-205" data-mp="3vduapsz5jdh6">
          <div className="mx-auto mt-10 max-w-2xl space-y-5 text-base leading-relaxed text-slate-300/90" data-id="element-206" data-mp="d5cvuey6zpza">
            <p data-id="element-207" data-mp="952tdc9lzhp6">
              I lead from the conviction that legal excellence and commercial ambition are not opposing
              forces. The most valuable enterprises are the ones where ethical decision-making is built
              into how the business operates — not appended to it after the fact. That requires a legal
              function that understands the P&amp;L, a compliance program that is measured rather than
              assumed, and a board that receives the truth early enough to govern with it.
            </p>
            <p data-id="element-208" data-mp="yzsee6qvr9z1">
              Integrity, in practice, is unglamorous: consistent judgment, documented reasoning, and the
              willingness to say the difficult thing to the person who least wants to hear it. Done well
              over years, that discipline compounds into something an organization can be valued on —
              trust with regulators, confidence from investors, and durable enterprise value.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-8 sm:grid-cols-3" data-id="element-209" data-mp="1mmidp0bugqfy">
          {principles.map((item, index) => <Reveal key={item.title} delay={0.24 + index * 0.07} data-id="element-210" data-mp="1rnxz4thxoyyv" data-mpi={index}>
              <div className="border-t border-gold/30 pt-5" data-id="element-211" data-mp="1wlhfbyy6zltg">
                <p className="eyebrow text-gold" data-id="element-212" data-mp="1wjn1t5p92vze">{item.title}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-213" data-mp="3tf1ajkznehkh">{item.text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}